export enum BannedGameTimeEnum {
  oneDay = "一天",
  threeDay = "三天",
  sevenDay = "七天",
  oneMonth = "一個月",
  forever = "永久",
}
